import utils from '@/services/utils';

export default {
  getQuizData(variables = {}) {
    return utils.get('/api/home/book/get/isExistValidityBook', variables);
  },
  readBook(variables = {}) {
    return utils.get('/api/home/user/update/studentLearnBookId', variables);
  },
};
